import { useQuery } from '@apollo/client'
import { SearchableCombobox, TSearchable } from '../base/combobox'
import { VenueSelectorQuery, SelectedVenueSelectorQuery } from './__generated__/selector_query'
import { Query, SelectedQuery } from './selector_query'
import { useCombobox } from '@/helpers/useCombobox'
import { dedupe } from '@/helpers/dedupe'

type Venue = SelectedVenueSelectorQuery['venues']['nodes'][0]

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { data: selectedData } = useQuery<SelectedVenueSelectorQuery>(
    SelectedQuery,
    { variables: { id: value || 'blank' } }
  )
  const { data, loading, refetch, fetchMore } = useQuery<VenueSelectorQuery>(Query, { variables: { first: 10 } })

  const { pageInfo, items } = useCombobox<Venue>({
    pageInfo: data?.venues.pageInfo,
    querySelected: selectedData?.venues.nodes[0],
    queryCollection: data?.venues.nodes,
    buildSearchable: item => ({
      id: item.id,
      name: item.name,
      detail: item.address
    })
  })

  return (
    <SearchableCombobox
      data={items}
      invalid={invalid}
      loading={loading}
      moreToFetch={pageInfo.current?.hasNextPage}
      refetch={refetch}
      searchField="nameCont"
      value={items.find(d => d.id == value) || { id: '', name: '' }}
      fetchMore={() => fetchMore({
        variables: { after: pageInfo.current?.endCursor },
        updateQuery(previousData, { fetchMoreResult }) {
          if (Object.keys(previousData).length === 0) return fetchMoreResult
          fetchMoreResult.venues.nodes = dedupe([
            ...previousData.venues.nodes,
            ...fetchMoreResult.venues.nodes
          ])

          return { ...fetchMoreResult }
        }
      })}
      onChange={onChange}
    />
  )
}
